import { render, staticRenderFns } from "./AddStartupsPreviewModal.vue?vue&type=template&id=7dbae437&scoped=true&"
import script from "./AddStartupsPreviewModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddStartupsPreviewModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddStartupsPreviewModal.vue?vue&type=style&index=0&id=7dbae437&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbae437",
  null
  
)

export default component.exports